/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberShiftsAvailableSlots200, GetApiBarberShiftsAvailableSlots400, GetApiBarberShiftsAvailableSlots401, GetApiBarberShiftsAvailableSlots403, GetApiBarberShiftsAvailableSlots404, GetApiBarberShiftsAvailableSlots500, GetApiBarberShiftsAvailableSlotsQueryParams, GetApiBarberShiftsAvailableSlotsQueryResponse } from "../entities/GetApiBarberShiftsAvailableSlots";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsShiftAvailableSlotsOutputSchema } from "./models/shiftAvailableSlotsOutputSchema";
import { z } from "zod/v4";

export const getApiBarberShiftsAvailableSlotsQueryParamsSchema = z.object({
    "from": z.string().describe("Дата начала периода"),
"to": z.string().describe("Дата конца периода")
    }) as unknown as z.ZodType<GetApiBarberShiftsAvailableSlotsQueryParams>

/**
 * @description OK
 */
export const getApiBarberShiftsAvailableSlots200Schema = z.lazy(() => modelsShiftAvailableSlotsOutputSchema) as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots200>

/**
 * @description Bad Request
 */
export const getApiBarberShiftsAvailableSlots400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots400>

/**
 * @description Unauthorized
 */
export const getApiBarberShiftsAvailableSlots401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots401>

/**
 * @description Forbidden
 */
export const getApiBarberShiftsAvailableSlots403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots403>

/**
 * @description Not Found
 */
export const getApiBarberShiftsAvailableSlots404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots404>

/**
 * @description Internal Server Error
 */
export const getApiBarberShiftsAvailableSlots500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsAvailableSlots500>

export const getApiBarberShiftsAvailableSlotsQueryResponseSchema = z.lazy(() => getApiBarberShiftsAvailableSlots200Schema) as unknown as z.ZodType<GetApiBarberShiftsAvailableSlotsQueryResponse>